import { render, staticRenderFns } from "./bao-cao-tai-chinh.vue?vue&type=template&id=627e1404&"
import script from "./bao-cao-tai-chinh.vue?vue&type=script&lang=js&"
export * from "./bao-cao-tai-chinh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports